export function scfmAcfmConvert(
  value: number,
  fromU: string,
  toU: string,
  conds: Record<string, number>,
  constants: Record<string, number>
): number {
  const T_std_R = constants.T_std_R;
  const P_std_psi = constants.P_std_psi;
  const T_actual_R = conds.T_actual + 459.67;
  const P_actual_psi = conds.P_atm_psi;

  // ICFM, NCFM, and CFM are equivalent to ACFM at site conditions
  const isStandard = (u: string) => u === 'scfm';
  const isActual = (u: string) => ['acfm', 'cfm', 'icfm', 'ncfm'].includes(u);

  if (isStandard(fromU) && isActual(toU)) {
    return value * (T_actual_R / T_std_R) * (P_std_psi / P_actual_psi);
  }
  if (isActual(fromU) && isStandard(toU)) {
    return value * (T_std_R / T_actual_R) * (P_actual_psi / P_std_psi);
  }
  throw new Error(`Unsupported direction: ${fromU} → ${toU}`);
}
